import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsProvider } from "../../@hooks"


export default function UserSettingsProvidersTabButton() {

    const { handleSetProviderFormData } = useUserSettingsProvider()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetProviderFormData}
    >
        Define Providers Color
    </ButtonLoadingSeeker>
}